import { FormSetting } from '@/form-settings/form-setting';

export class ActionPracticeFormSetting extends FormSetting {
  protected static classToCall: string;

  public static setClassToCall(classes) {
    this.classToCall = classes;

    return this;
  }

  public static getMeta(): Array<any> {
    return [
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'codiceAzione',
            controlType: 'textinput',
            label: 'Codice Azione',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'marca',
            controlType: 'dropdown',
            label: 'Marca',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
            options: this.data['brands'] ?? [],
          },
          {
            classToUse: this.classToCall,
            key: 'enabled',
            controlType: 'slide-toggle',
            label: 'Abilitato',
            default: true,
            order: 1,
            class: 'lg:w-4/12 w-full',
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'descrizione',
            label: 'Descrizione',
            controlType: 'textinput',
            class: 'lg:w-12/12 w-full',
            order: 1,
            required: true,
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'conteggiaAzione',
            controlType: 'slide-toggle',
            label: 'Conteggia azione',
            default: true,
            order: 1,
            class: 'lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'negativa',
            controlType: 'slide-toggle',
            label: 'Azione negativa',
            default: false,
            order: 1,
            class: 'lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'volkswagenBank',
            controlType: 'slide-toggle',
            label: 'Azione Volkswagen Bank',
            default: false,
            order: 1,
            class: 'lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'tipologiaAzione',
            label: 'Tipologia azione',
            controlType: 'textinput',
            class: 'lg:w-4/12 w-full',
            order: 1,
            required: true,
            default: 'A',
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'id',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
          {
            classToUse: this.classToCall,
            key: 'creator',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
        ],
        order: 1,
      },
    ];
  }
}
